module.exports = __webpack_public_path__ + "img/202012141333035414js.0fed7661.png";